import styled from 'styled-components'
import { RectangleBadge } from '@/features/shared/elements/Badges'
import { type BadgeType } from '@/features/shared/elements/Badges/types'

type Props = {
  productTextBadges: BadgeType[]
  productQuantity: number
  purchaseLimit: number
}
export const ProductTextBadge = ({
  productTextBadges,
  productQuantity = 0,
  purchaseLimit = 0,
}: Props) => {
  return (
    <BadgeWrapper>
      {productTextBadges.map((text) => (
        <li key={`ProductTextBadge-${text}`}>
          {productQuantity >= purchaseLimit && purchaseLimit > 0 && text === 'limit' && (
            <ProductBadge type={text} key={text} limit={purchaseLimit} />
          )}
          {text !== 'limit' && <ProductBadge type={text} key={text} />}
        </li>
      ))}
    </BadgeWrapper>
  )
}

const BadgeWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  margin: 0;
  margin-right: 4px;
  list-style: none;
  padding: 0;
`

const ProductBadge = styled(RectangleBadge)`
  margin: 0.5rem 0.5rem 0.5rem 0;
`
